export const SETTINGS_UPDATE_LAST_SELECTED_BRAND = 'SETTINGS_UPDATE_LAST_SELECTED_BRAND'
export const SETTINGS_READ_LAST_SELECTED_BRAND = 'SETTINGS_READ_LAST_SELECTED_BRAND'
